export function getOptionRentalData(option: any, points: number, caption: string) {
  if (!option) return null as any;
  return {
    loanTerm: "30 years",
    originationPoints: points,
    rate: (option.total_rate * 100).toFixed(3),
    monthlyPayment: option.monthly_payment,
    caption,
    totalLoanAmount: option.loan_amount,
    ltv: option.ltv,
    buydownPoints: points,
    cashoutAmount: option.cashout_amount,
    dscr: option.dscr,
    programName: option.is_flex ? "Flex" : (option.is_extended ? "Expanded" : (option.is_plus ? "Plus" : "Standard")),
    bondPrice: option.bond_price
  }
}

export function getOptionShortTermData(option: any, points: number, caption: string) {
  if (!option) return null as any;
  return {
    loanTerm: "12 months",
    originationPoints: points,
    rate: (option.rate * 100).toFixed(2),
    monthlyPayment: option.monthly_payment,
    caption,
    totalLoanAmount: option.advance_amount_max || option.total_loan_amount,
    ltv: option.ltv,
    buydownPoints: points,
    cashoutAmount: option.cashout_amount,
    ltc: option.ltc
  }
}

